import styled from 'styled-components';
import { pxToRem, vars } from '$util/theme';

export const Styled = styled.div`
  .title {
    font-size: ${pxToRem(22)};
    font-weight: ${vars.fontWeight.semiBold};
    line-height: 28px;
    margin-bottom: 25px;

    p {
      font-size: ${pxToRem(14)};
      line-height: 24px;
      margin-top: 12px;
    }

    .btn-link {
      text-decoration-color: ${vars.quantumverse.reskinColors.purple500};
      > span {
        font-size: ${pxToRem(14)};
        color: ${vars.quantumverse.reskinColors.purple500};
      }
    }
  }
`;
